__turbopack_context__.v({
  "caption": "sectionWithImages-module-scss-module__poXeRW__caption",
  "featuresList": "sectionWithImages-module-scss-module__poXeRW__featuresList",
  "multipleImagesWrp": "sectionWithImages-module-scss-module__poXeRW__multipleImagesWrp",
  "multipleScreenshotWrp": "sectionWithImages-module-scss-module__poXeRW__multipleScreenshotWrp",
  "screenshot": "sectionWithImages-module-scss-module__poXeRW__screenshot",
  "screenshotImageWrp": "sectionWithImages-module-scss-module__poXeRW__screenshotImageWrp",
  "screenshotWrp": "sectionWithImages-module-scss-module__poXeRW__screenshotWrp",
  "tabContent": "sectionWithImages-module-scss-module__poXeRW__tabContent",
});
